module.exports = __webpack_public_path__ + "static/media/allygn-start-logo-white.9febe3cb.svg";